<template>
  <div
    :class="{
      'coh-Header-with-top-border': withTopBorder
    }"
    class="coh-Header"
  >
    <div class="coh-Header_Title oboard-truncated-text">
      <slot name="cell:item-name">
        {{ $t('objectives.table_header_name') }}
      </slot>
    </div>
    <div class="coh-Header_Right">
      <div class="coh-HeaderRight_Interval oboard-truncated-text">
        {{ $t('objectives.table_header_interval') }}
      </div>
      <div class="coh-HeaderRight_Grade oboard-truncated-text">
        {{ $t('objectives.table_header_grade') }}
      </div>
      <div class="coh-HeaderRight_Assignee" />
      <div class="coh-HeaderRight_Checkin oboard-truncated-text">
        {{ $t('objectives.table_header_checkin') }}
      </div>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'CardObjectivesHeader'
})

defineProps({
  withTopBorder: {
    type: Boolean
  }
})
</script>

<style lang="scss" scoped>
.coh-Header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #{$grey-2-next};
  padding: 8px 24px;

  color: #{$grey-1};

  font-size: $fs-12;
  font-weight: fw('regular');
  line-height: 18px;

  --checkin-header-cell-width: calc(
    var(--right-items-gap) + var(--okr-table-checkin-cell-width) +
      var(--okr-table-row-controls-button-width)
  );

  &-with-top-border {
    border-top: 1px solid #{$grey-2-next};
  }
}

.coh-Header_Title {
  min-width: 0;
}

.coh-Header_Right {
  display: flex;
  gap: var(--right-items-gap, 12px);
  flex-shrink: 0;
}

.coh-HeaderRight_Grade,
.coh-HeaderRight_Checkin {
  cursor: default;
}

.coh-HeaderRight_Assignee {
  width: 24px;
}

.coh-HeaderRight_Grade {
  width: var(--grade-header-cell-width);
  text-align: center;
}

.coh-HeaderRight_Interval {
  width: var(--ob-oeli-interval-width);
}

.coh-HeaderRight_Checkin {
  padding-left: 5px;
  width: var(--checkin-header-cell-width);
}
</style>
